import React from "react";

export default function Web_GitHub() {
  return (
    <div>
      <h1>What is GitHub</h1>
      <p>
        Route: <code>/web/github</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
